import { type Node } from 'react';

type Props = {| children: Node |};

export default ({ children }: Props) => <div>{children}</div>;
